import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { error } from 'selenium-webdriver';
import { Router, RouterModule, Routes } from '@angular/router';

@Component({
  selector: 'app-mypaths',
  templateUrl: './mypaths.component.html',
  styleUrls: ['./mypaths.component.scss']
})
export class MypathsComponent implements OnInit {
  myPathsObj:any=[];
  explorePathsObj:any=[];
  routerUrl:string='';
  myPathsTab:boolean = true;
  constructor(private homeService:HomeService, private router:Router) { }

  ngOnInit() {
    this.myPaths();
    this.explorePaths();
    this.pathTabs();
  }

  myPaths() {
    this.homeService.myPaths().subscribe(res=>{
      if(res) {
        this.myPathsObj = res['results'];
      }
    },error=>{
      //Error
    });
  }

  explorePaths() {
    this.homeService.explorePaths().subscribe(res=>{
      if(res) {
        this.explorePathsObj = res['results'];
      }
    },error=>{
     //Error
    });
  }

  pathTabs() {
    this.routerUrl = this.router.url;
    if(this.routerUrl == '/my-paths') {
      this.myPathsTab = true
    }else {
      this.myPathsTab = false;
    }
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/mypaths/mypaths.component.ts